import React, { useEffect, useState } from "react";
import { Button, Divider, Menu } from "antd";
import { FaUsers, FaVolleyballBall } from "react-icons/fa";
import {
  GiAmericanFootballHelmet,
  GiAmericanFootballPlayer,
  GiBasketballBasket,
  GiBoxingGloveSurprise,
  GiHockey,
  GiSoccerBall,
} from "react-icons/gi";
import type { MenuProps } from "antd";
import { useUser } from "../../../DataProvider";
import { Link } from "react-router-dom"; // Import Link from React Router
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  QuestionCircleOutlined,
  StarOutlined,
} from "@ant-design/icons";
import {
  MdArticle,
  MdFilterList,
  MdPayment,
  MdSportsRugby,
} from "react-icons/md";
import { FaBasketballBall } from "react-icons/fa";
import { GiRaceCar } from "react-icons/gi";
import { FaBaseballBatBall } from "react-icons/fa6";
import { TbPlayHandball } from "react-icons/tb";
import { PiCards } from "react-icons/pi";
import { CiAlignTop, CiGlobe } from "react-icons/ci";
import { CgWebsite } from "react-icons/cg";

type MenuItem = Required<MenuProps>["items"][number];

type MenuItemWithChildren = MenuItem & { children?: MenuItem[] };

const menuItems: MenuItem[] = [
  // {
  //   key: "0",
  //   icon: <MdFilterList />,
  //   label: <Link to="/categories">Categories</Link>,
  // },
  {
    key: "1",
    icon: <MdArticle />,
    label: <Link to="/articles">Articles</Link>,
  },
  {
    key: "2",
    icon: <CgWebsite />,
    label: <Link to="/main-news">Main News</Link>,
  },
  {
    type: "divider",
  },
  {
    key: "3",
    icon: <StarOutlined />,
    label: <Link to="/statistics">Statistics</Link>,
  },
  {
    type: "divider",
  },
  /* {
    key: "4",
    icon: <FaUsers />,
    label: <Link to="/users">Users</Link>,
  },*/
];

const App: React.FC = () => {
  const [filteredItems, setFilteredItems] = useState<MenuItem[]>([]);
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    if (user) {
      // Filter menu items based on user permissions
      const filtered = menuItems.filter((item) => {
        const key = Number(item?.key);
        // Categories permission
        if (key === 0 && !user.Permissions.Categories) return false;
        // Articles permission
        if (key === 1 && !user.Permissions.Articles) return false;
        // Main News is part of Articles permission
        if (key === 2 && !user.Permissions.Articles) return false;
        // Statistics permission
        if (key === 3 && !user.Permissions.Statistics) return false;
        // Users permission
        if (key === 4 && !user.Permissions.Users) return false;

        return true;
      });
      setFilteredItems(filtered);
    } else {
      setFilteredItems([]);
    }
  }, [user]);

  return (
    <div>
      <Button className=" w-full" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <ArrowRightOutlined /> : <ArrowLeftOutlined />}
      </Button>
      <Menu
        inlineCollapsed={collapsed}
        mode="inline"
        className={collapsed ? " w-auto" : "w-80"}
        items={filteredItems.length > 0 ? filteredItems : []}
      />
    </div>
  );
};

export default App;
